import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

interface PropsModalSoporte {
    showModalSoporte: boolean;
    setShowModalSoporte: (show: boolean) => void;
}

const ModalSoporte = ({ showModalSoporte, setShowModalSoporte }: PropsModalSoporte) => {
    return (
        <Modal
            style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}
            show={showModalSoporte}
            dialogClassName="modal-cambiar-password"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            animation={false}
            onHide={() => setShowModalSoporte(false)}
        >
            <Modal.Header
                style={{
                    backgroundColor: '#528bf5',
                    padding: '1rem',
                    borderTopLeftRadius: '5px',
                    borderTopRightRadius: '5px',
                    color: 'white',
                }}
                closeButton={false}
            >
                <Modal.Title>Soporte Técnico</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ textAlign: 'left', padding: '2rem' }}>
                <div className="contact-info">
                    <h4>Sebastian Albertini</h4>
                    <p><FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:salbertini@banksa.com.ar">salbertini@banksa.com.ar</a></p>
                    <p><FontAwesomeIcon icon={faPhone} /> 11-3260-3817</p>
                </div>
                <hr/>
                <div className="contact-info">
                    <h4>Adrian Alfosin</h4>
                    <p><FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:aalfonsin@bansa.com.ar">aalfonsin@bansa.com.ar</a></p>
                    <p><FontAwesomeIcon icon={faPhone} />5352-5567</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={() => setShowModalSoporte(false)}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSoporte;
